'use client'

import { Description } from '@features/faucet.components/Description'
import { FaqSection } from '@features/faucet.components/FaqSection'
import { Footer } from '@features/faucet.components/Footer'
import { Header } from '@features/faucet.components/Header'
import { useFeatureFlag } from '@features/flags.hooks/useFeatureFlag'

import { RequestToken } from '../RequestToken/RequestToken'

import type { FaucetEventOverrideAmounts } from '@features/faucet.graphql/datasources/FaucetApi/eventOverrides'

interface PageProps {
  eventId?: string
  eventOverrideAmounts?: FaucetEventOverrideAmounts
}

export const Page = ({ eventId, eventOverrideAmounts }: PageProps) => {
  const faucetFaqEnabled = useFeatureFlag('faucetFaqEnabled')

  return (
    <div className="min-h-screen w-full">
      <div className="fixed top-0 z-30 w-full border-b border-neutral-subtle bg-white">
        <Header />
      </div>
      {faucetFaqEnabled ? (
        <div className="flex min-h-screen w-full flex-col items-center justify-center gap-6 bg-white px-4 py-24 sm:gap-8 sm:px-12 sm:pt-32 lg:flex-row lg:items-start lg:gap-16">
          <div className="w-full max-w-lg">
            <RequestToken
              eventId={eventId}
              eventOverrideAmounts={eventOverrideAmounts}
            />
          </div>
          <div className="w-full max-w-lg">
            <FaqSection />
          </div>
        </div>
      ) : (
        <div className="flex min-h-screen w-full grow flex-col-reverse items-center justify-center lg:flex-row">
          <div className="flex min-h-152 w-full shrink-0 grow items-center justify-center bg-accent-purple-gradient px-6 py-24 lg:h-screen lg:w-1/2">
            <Description />
          </div>
          <div className="flex min-h-152 w-full shrink-0 grow items-center justify-center bg-white px-6 py-24 lg:h-screen lg:w-1/2">
            <div className="w-full max-w-lg">
              <RequestToken
                eventId={eventId}
                eventOverrideAmounts={eventOverrideAmounts}
              />
            </div>
          </div>
        </div>
      )}
      <div className="w-full">
        <div className="-mt-20 px-6 py-2 md:px-12 lg:-mt-12">
          <Footer />
        </div>
      </div>
    </div>
  )
}
